/**
 * @generated SignedSource<<1fa1132385cd95ab2b6fb6f0efed71f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLJobRunStatus = "COMPLETED" | "ERRORED" | "IN_PROGRESS" | "PENDING" | "STOPPED" | "%future added value";
export type RerunJobInput = {
  jobRunId: any;
};
export type RerunJobMutation$variables = {
  input: RerunJobInput;
};
export type RerunJobMutation$data = {
  readonly rerunJob: {
    readonly jobRun: {
      readonly id: any;
      readonly status: GraphQLJobRunStatus;
    };
    readonly success: boolean;
  };
};
export type RerunJobMutation = {
  response: RerunJobMutation$data;
  variables: RerunJobMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RerunJobPayload",
    "kind": "LinkedField",
    "name": "rerunJob",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLJobRun",
        "kind": "LinkedField",
        "name": "jobRun",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RerunJobMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RerunJobMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b0a3312ec916abd080d08446d5662e1d",
    "id": null,
    "metadata": {},
    "name": "RerunJobMutation",
    "operationKind": "mutation",
    "text": "mutation RerunJobMutation(\n  $input: RerunJobInput!\n) {\n  rerunJob(input: $input) {\n    success\n    jobRun {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5b2cfd2c929d33b20155c5b45e91c1cf";

export default node;
